import type { BakeRequest } from './map-generate.js';

/**
 * Состояние сеанса: кто вошёл и с какой картой работаем.
 *
 * ⚠️ ЧЕТЫРЕ ПЕРЕМЕННЫЕ, КОТОРЫЕ ДЕРЖАЛИ ВЕСЬ main.ts ВМЕСТЕ.
 *
 * Они лежали россыпью на разной глубине файла и читались-писались отовсюду:
 * токен на строке 251, имя карты на 2593, выбранная локация на 3007. При этом
 * `currentWorldName` ПИСАЛСЯ на строке 1268 — за тысячу триста строк до своего
 * объявления. Работало это лишь потому, что запись случается внутри функции,
 * которую зовут позже; переставь кто-нибудь вызов выше — и переменная
 * оказалась бы в мёртвой зоне, а игра упала бы на ровном месте.
 *
 * Пока файл был один, это сходило с рук: всё видно в одном месте. Но именно
 * эти четыре имени не давали вынести сетевую проводку (39.7 КБ) и панель карт
 * (35 КБ) — каждый кусок цеплялся за них, и переносить его значило оставить
 * половину связей висеть в воздухе.
 *
 * ⚠️ ЭТО НЕ «ГЛОБАЛЬНОЕ ХРАНИЛИЩЕ ВСЕГО», И ТАКИМ СТАНОВИТЬСЯ НЕ ДОЛЖНО.
 * Здесь только то, что описывает СЕАНС: кто вошёл и какая карта открыта.
 * Появится соблазн положить сюда погоду, снасть или список соседей — значит
 * тем вещам нужен свой дом, а не этот.
 */

/** Токен входа. Живёт между перезагрузками — отсюда и чтение из хранилища. */
let token: string | null = localStorage.getItem('if-auth-token');

/**
 * Название открытой карты.
 *
 * ⚠️ ПОМНИТСЯ МЕЖДУ СОХРАНЕНИЯМИ, И ЭТО НЕ УДОБСТВО, А ЗАЩИТА ОТ СВАЛКИ.
 * Без памяти каждое «Сохранить» просило бы имя заново, человек жал бы Enter,
 * и в папке копились бы «Свитязь», «Свитязь1», «Свитязь окончательный».
 */
let worldName: string | null = null;

/**
 * Какую локацию выбрали до запуска движка.
 *
 * ⚠️ ПЕРЕДАТОЧНОЕ ЗВЕНО МЕЖДУ ЭКРАНОМ ВХОДА И ИГРОЙ. Игра — модуль, который
 * сам себя запускает при ввозе, и принять довод ему некуда. Этот же файл
 * свободен от движка и виден обеим сторонам: боот кладёт сюда выбор, игра
 * забирает его при старте.
 */
let pendingWorldFile: string | null = null;

/**
 * Какая рыба водится в выбранном водоёме. null — про водоём ничего не знаем.
 *
 * ⚠️ НУЖНО ЗАПАСНОМУ ИСТОЧНИКУ ПОКЛЁВОК, ТОМУ, ЧТО РАБОТАЕТ БЕЗ СЕРВЕРА.
 * Обычно вид рыбы разыгрывает сервер и про галочки админа знает. Но игра
 * должна ловиться и с выдернутым шнуром — иначе разработка встаёт всякий раз,
 * когда сервер не поднят. Без этого поля в таком режиме клевало бы всё подряд,
 * и снятая галочка оказалась бы правдой только при живом сервере.
 */
let allowedFish: string[] | null = null;

/** Локация, выбранная на карте мира: по ней печётся водоём. */
let location: BakeRequest | null = null;

/** Что напекла карта мира в последний раз. */
let bake: BakeRequest | null = null;

export const session = {
  get token(): string | null {
    return token;
  },
  set token(v: string | null) {
    token = v;
  },

  get pendingWorldFile(): string | null {
    return pendingWorldFile;
  },
  set pendingWorldFile(v: string | null) {
    pendingWorldFile = v;
  },
  get worldName(): string | null {
    return worldName;
  },
  set worldName(v: string | null) {
    worldName = v;
  },

  get allowedFish(): string[] | null {
    return allowedFish;
  },
  set allowedFish(v: string[] | null) {
    allowedFish = v;
  },

  get location(): BakeRequest | null {
    return location;
  },
  set location(v: BakeRequest | null) {
    location = v;
  },

  get bake(): BakeRequest | null {
    return bake;
  },
  set bake(v: BakeRequest | null) {
    bake = v;
  },
};
